export default __webpack_public_path__ + "static/media/polk_p_epic.7a36dfe2.png";